import Axios from 'axios'
import router from '../router'
import util from '@/utils/util'
import { Toast, Indicator } from 'mint-ui';
import {
    getToken,
} from '@/utils/auth'
const qs = require('qs')
Axios.defaults.timeout = 30000;
// Axios.interceptors.request.use(config => {
//     config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
//     return config;
// }, error => {
//     console.log('request_error:' + error)
//     return Promise.reject(error);
// });

Axios.interceptors.response.use(response => {
    return response;
}, error => {
    return Promise.reject(error);
});

/**
 * 公共请求入口
 * @param param 'object'
 * @param url   'string'
 * @param type  'get || post'
 * @returns {Promise}
 */
export const commonPromise = (param = {}, url, type = 'post', requestType = '',isShowLogin = true) => {
    return new Promise((resolve, reject) => {
        let request;
        // 校验参数（不可传undefined和null），过滤空格
        for (let index in param) {
            if (util.isBlank(param[index])) {
                param[index] = '';
            } else if (typeof param[index] === 'string') {
                param[index] = param[index].replace(/(^[\s\n\t]+|[\s\n\t]+$)/g, "");
            }
        }
        Axios.defaults.baseURL = process.env.BASE_API;
        url = url + '?token=' + getToken() || '';
        if (type == 'get' || type == 'GET') {
            for (let key in param) {
                url = url + '&' + key + '=' + param[key]
            }
            url = url + '&t=' + Date.now()
        }
        let requestBody = {
            url: url,
            method: type,
            data: param,
        };
        if (requestType == 'form') {
            requestBody.headers = { 'Content-Type': 'multipart/form-data' };
            let formData = new FormData();
            for (let key in param) {
                formData.append(key, param[key]);
            }
            requestBody.data = formData;
        }
        request = Axios(requestBody);
        if (isShowLogin) {
            Indicator.open({
                text: 'Loading...'
            });
        }
        request.then(res => {
            Indicator.close();
            if (res.data.code === 0) {
                resolve(res.data);
            } else if (res.data.code == 401) {
                // 用户登录过期
                Toast('账号在其他设备登录');
                setTimeout(() => {
                    localStorage.removeItem('userId');
                    sessionStorage.removeItem('initCurDiscountInfo');
                    router.push('/');
                }, 1000);
            } else {
                // 各个接口不统一处理，需要“特殊情况特殊处理”
                reject(res.data);
            }
        }).catch(err => {
            console.log('err', err);
            Indicator.close();
            if (err.message && err.message === 'timeout of 30000ms exceeded') {
                Toast('网络请求超时,请稍后重试');
            } else {
                Toast('网络连接异常,请检查网络或者稍后重试');
            }
            // reject(err.message);
        });
    })
}



// WEBPACK FOOTER //
// ./src/http/index.js